import TitleIcon, { type TitleIconTone } from '@/components/atoms/TitleIcon/TitleIcon';
import type { TaskPriority } from '@/domain/operationalDashboard';
import { getTaskIcon } from '@/domain/operationalDashboard';

interface TaskPriorityIconProps {
    priority: TaskPriority;
    alertCode: string | null;
}

const PRIORITY_TONE: Record<TaskPriority, TitleIconTone> = {
    critical: 'priorityCritical',
    high: 'priorityHigh',
    warning: 'priorityWarning',
    low: 'priorityLow',
};

export default function TaskPriorityIcon(props: TaskPriorityIconProps) {
    const { priority, alertCode } = props;

    return <TitleIcon icon={getTaskIcon(alertCode)} tone={PRIORITY_TONE[priority]} />;
}
